<template>
    <div class="scrollfix">
        <div v-if="processingStatus">
            <div v-if="displayProcessing">
                Načítám...
            </div>
        </div>
        <div v-else-if="unitData" class="scrollfix">
            <div class="vertical-container">
                <div class="vertical-container__header vertical-container__header--has-shadow">
                    <div class="container">
                        <h1 class="section-title">Jednotka {{ designation }}</h1>
                    </div>
                </div>

                <div class="vertical-container__content">
                    <unit-container/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import UnitContainer from '../components/UnitContainer';

export default {
    components: {UnitContainer},
    computed:   {
        designation() {
            return this.$store.getters['projects/project/units/unit/designation'];
        },
        processingStatus() {
            return this.$store.getters['projects/project/units/unit/processingStatus'];
        },
        unitData() {
            return this.$store.getters['projects/project/units/unit/unitData'];
        }
    },
    data() {
        return {
            timeout:           null,
            displayProcessing: false,
        }
    },
    watch:      {
        processingStatus: function (nextValue) {
            if (nextValue) {
                this.timeout = setTimeout(() => this.displayProcessing = true, 1000);
            }
            if (!nextValue && this.timeout) {
                this.displayProcessing = false;
                clearTimeout(this.timeout);
            }
        }
    }
}
</script>
